import { useState } from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";
import Wrapper from "../../helpers/Wrapper";
import Logo from "../../assets/images/SVG/logo-outline.svg";
import MediaQuery, { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import { SwiperButtonNext } from "../../components/button/SwiperButton";
import axios from "axios";
import MainParticles from "../../components/Particles/MainParticles";

function Success() {
  const navigate = useNavigate();
  const isPortrait = useMediaQuery({
    query: "(orientation: portrait)",
  });

  return (
    <Wrapper>
      <Container>
        <EarlyAccessContainerLeft>
          <EarlyAccessLeft>
            <EarlyAccessLeftTop>
              <section>
                <img
                  style={{ textAlign: "center" }}
                  className="logo-img top-img"
                  src={Logo}
                  onClick={() => navigate("/")}
                />
              </section>
              <div className="early_access_container">
                {!isPortrait && <h1>Successfully Submitted!</h1>}
                {isPortrait && (
                  <h1 style={{ textAlign: "center" }}>
                    Successfully Submitted!
                  </h1>
                )}
                <div className="input__wrap">
                  <button onClick={() => navigate("/")}>Back To Home</button>
                </div>
              </div>
            </EarlyAccessLeftTop>
          </EarlyAccessLeft>
        </EarlyAccessContainerLeft>

        {!isPortrait && (
          <EarlyAccessContainerRight>
            <section className="logo-img-large-container">
              <img className="logo-img-large" src={Logo} />
            </section>
          </EarlyAccessContainerRight>
        )}
      </Container>
      <MainParticles />
    </Wrapper>
  );
}

export default Success;

const EarlyAccessContainerLeft = styled.div`
  display: flex;
  color: white;
  background-color: #171717;
  width: 500px;
  height: 100vh;

  .disclaimer {
    display: block;
    font-size: 14px;
    padding-top: 50px;
    width: 300px;

    u {
      :hover {
        cursor: pointer;
        text-decoration: none;
      }
    }
  }

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const Container = styled.div`
  display: flex;
`;

const EarlyAccessLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
`;

const EarlyAccessLeftTop = styled.div`
  align-items: center;

  > section {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 20px;
    > p {
      margin-left: 10px;
    }
  }

  h1 {
    font-size: 52px;
    align-items: left;
    text-align: left;
    margin-bottom: 100px;
    margin: 47px 0px 47px 9px;
  }

  .telem__slogan {
    font-size: 18px;
    line-height: 1.55;

    margin: 47px 0px 47px 10px;
  }
  .email__input {
    display: block;
    width: 300px;
    font-weight: 700;
    align-items: left;
    padding: 12px 24px;
    margin: 10px;
    text-align: center;
    color: white;
    border-radius: 12px !important;
    background-color: #0a0a0a;
    padding: 0.5rem;
    border: 0px;
    line-height: 24px;
    font-size: 15px;
    border: double 2px transparent;
    border-radius: 6px;
    background-image: linear-gradient(#0a0a0a, #0a0a0a),
      linear-gradient(to right, #36add8, #1e3b8b);
    background-origin: border-box;
    transition: background-color 0.2s ease-out 0s;
  }

  .input__wrap > button {
    font-weight: bold;

    height: 100%;
    width: 320px;
    color: aliceblue;
    border-radius: 12px;
    border: none;
    background-image: linear-gradient(
      to right,
      #1e3b8b 0%,
      #36add8 51%,
      #1e3b8b 100%
    );
    background-size: 200% auto;
    letter-spacing: 0.5px;
    font-family: "Poppins-Bold";
    border: 0px;
    display: block;
    font-size: 14px;
    line-height: 24px;
    padding: 12px 24px;
    margin: 10px;
    transition: 0.8s ease-out 0s;
    cursor: pointer;
    :hover {
      background-position: right center;
      opacity: 0.8;
    }
  }
`;
const EarlyAccessContainerRight = styled.div`
  flex: 1;
  align-self: stretch;
  display: flex;

  > section {
    flex: 1;
    align-self: stretch;

    width: 100%;
  }

  > section > img {
    display: flex;
    margin: 25px;
    cursor: pointer;
  }

  > section > p {
    margin-left: 20px;
    font-size: 24px;
    color: white;
  }
  @media (max-width: 900px) {
    display: none;
  }
`;
